import { ReactNode } from "react";
import { colors } from "../../../styles";
import { BaseStack } from "../../layout";

interface TutorialCarouselProps {
  currentIndex: number;
  CarouselItems: ReactNode[];
  FixedButtons: ReactNode;
}

const TutorialCarousel = ({
  currentIndex,
  CarouselItems,
  FixedButtons,
}: TutorialCarouselProps) => {
  return (
    <BaseStack width="100%" alignItems="center" backgroundColor={colors.white}>
      <BaseStack maxWidth="480px" width="100%" style={{ minHeight: "100vh" }}>
        {/* 튜토리얼 콘텐츠 */}
        {CarouselItems[currentIndex]}

        {/* 하단 여백 */}
        <div style={{ height: "96px" }} />

        {/* FixedBottomCTA */}
        <BaseStack
          position="fixed"
          width="100%"
          maxWidth="480px"
          bottom={0}
          left={0}
          right={0}
          margin="0 auto"
          zIndex={100}
        >
          {/* 그라데이션 - 40px (dots가 중앙에 위치) */}
          <div style={{ width: "100%", height: "40px", position: "relative" }}>
            <div
              style={{
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.16) 24%, rgba(255,255,255,0.75) 70%, #FFF 100%)",
              }}
            />
            {/* 페이지네이션 dots - 그라데이션 중앙에 위치 */}
            <BaseStack
              direction="horizontal"
              gap="8px"
              justifyContent="center"
              position="absolute"
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            >
              {CarouselItems.map((_, index) => (
                <div
                  key={index}
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor:
                      index === currentIndex ? colors.gray900 : colors.gray200,
                  }}
                />
              ))}
            </BaseStack>
          </div>

          {/* 버튼 영역 */}
          <div
            style={{
              width: "100%",
              backgroundColor: colors.white,
              padding: "8px 20px 20px 20px",
            }}
          >
            {FixedButtons}
          </div>
        </BaseStack>
      </BaseStack>
    </BaseStack>
  );
};

export { TutorialCarousel };
export default TutorialCarousel;
